import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import FavoriteButton from './FavoriteButton';

const PopularVendors = ({ limit = 10, showTitle = true }) => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    fetchPopularVendors();
  }, []);

  const fetchPopularVendors = async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/favorites/vendors/popular?limit=${limit}`);
      if (res.ok) {
        const data = await res.json();
        setVendors(data || []);
      }
    } catch (error) {
      console.error('Error fetching popular vendors:', error);
    } finally {
      setLoading(false);
    }
  };

  const getVendorLink = (vendor) => {
    const role = vendor.role === 'hub' ? 'hub' : 'producer';
    return `/${role}/${vendor.slug || vendor.vendorId}`;
  };

  if (loading) {
    return (
      <div className="popular-vendors">
        {showTitle && <h3 className="text-lg font-semibold mb-4">🔥 Popular Vendors</h3>}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {[1, 2, 3, 4, 5].map(i => (
            <div key={i} className="animate-pulse bg-gray-50 rounded-lg p-4 h-24" />
          ))}
        </div>
      </div>
    );
  }

  if (vendors.length === 0) {
    return null;
  }

  return (
    <div className="popular-vendors">
      {showTitle && (
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">🔥 Popular Vendors</h3>
          <Link to="/producers" className="text-sm text-green-600 hover:underline">
            View All →
          </Link>
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {vendors.map((vendor) => (
          <div key={vendor.vendorId} className="border rounded-lg p-4 hover:shadow-md transition">
            <div className="flex flex-col items-center text-center">
              <Link to={getVendorLink(vendor)} className="w-full">
                <div className="w-16 h-16 rounded-full bg-gray-100 mx-auto mb-2 overflow-hidden">
                  {vendor.logo ? (
                    <img src={vendor.logo} alt={vendor.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-2xl bg-green-100">
                      🌱
                    </div>
                  )}
                </div>
                <p className="font-medium text-sm hover:text-green-600 hover:underline line-clamp-1">
                  {vendor.name}
                </p>
              </Link>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-gray-500">❤️ {vendor.favoriteCount}</span>
                <FavoriteButton vendorId={vendor.vendorId} size="sm" />
              </div>
              <span className="text-xs text-gray-400 mt-1">
                {vendor.role === 'hub' ? '🏪 Hub' : '🌱 Producer'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PopularVendors;
